// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"771":"2fa35897","868":"174d846b"}[chunkId] + ".chunk.js";
};